// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconClose = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M20.277 19.218c.29.29.29.77 0 1.06-.15.15-.34.22-.53.22s-.38-.07-.53-.22l-6.97-6.97-6.97 6.97c-.15.15-.34.22-.53.22s-.38-.07-.53-.22a.754.754 0 010-1.06l6.97-6.97-6.97-6.97a.754.754 0 010-1.06c.29-.29.77-.29 1.06 0l6.97 6.97 6.97-6.97c.29-.29.77-.29 1.06 0 .29.29.29.77 0 1.06l-6.97 6.97 6.97 6.97z"
      fill="currentColor"
    />
  );
export default SvgIconClose;
